import { render, staticRenderFns } from "./HuDongXieZuo.vue?vue&type=template&id=b318d910&scoped=true"
import script from "./HuDongXieZuo.vue?vue&type=script&lang=js"
export * from "./HuDongXieZuo.vue?vue&type=script&lang=js"
import style0 from "./HuDongXieZuo.vue?vue&type=style&index=0&id=b318d910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b318d910",
  null
  
)

export default component.exports